import { useEffect, useRef, useState } from "react";
import cn from "classnames";
import PropsTypes from "prop-types";

import { Modal } from "shared/components/Modals/Modal";

import { simplyClick } from "shared/helpers/analytics";

import { DeactivateStepOne } from "./steps/StepOne";
import { DeactivateStepTwo } from "./steps/StepTwo";

import styles from "@platformAssets/components/DeactivateModal.module.scss";
import stylesModal from "@platformAssets/components/Modal.module.scss";

import { ReactComponent as SignOutIcon } from "assets/shared/img/icons/signout.svg";
import { ReactComponent as TrashIcon } from "assets/shared/img/icons/trash.svg";

const DeactivateModal = ({
  show,
  handleCloseClick,
  isDeleted = false,
  onDeletedSuccess,
  StepTwoComponent = DeactivateStepTwo,
  username,
}) => {
  const modalBodyRef = useRef(null);

  const [showState, setShowState] = useState(show);

  const [step, setStep] = useState(0);

  useEffect(() => {
    if (show !== showState) {
      setShowState(show);
    }
  }, [show]);

  useEffect(() => {
    if (!modalBodyRef.current) {
      return;
    }

    requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"));
    });
  }, [step]);

  return (
    <Modal
      bodyRef={modalBodyRef}
      bodyClass={stylesModal.Deactivate}
      show={showState}
      closeModalOnClickOutside={false}
      close={(event) => {
        handleCloseClick(event);

        simplyClick(window.simplyEvent.cl_deactiv_prof_close);
      }}
      hideClose={isDeleted}
      isAnimated
    >
      {!isDeleted ? (
        <div className={cn(styles.img, styles.deactivateImage)}>
          <TrashIcon />
        </div>
      ) : (
        <div className={cn(styles.img, styles.deletedImage)}>
          <SignOutIcon />
        </div>
      )}

      {step === 0 ? (
        <DeactivateStepOne
          handleCloseClick={handleCloseClick}
          setStep={setStep}
          username={username}
        />
      ) : (
        <StepTwoComponent
          handleCloseClick={handleCloseClick}
          setShowState={setShowState}
          isDeleted={isDeleted}
          onDeletedSuccess={onDeletedSuccess}
          username={username}
        />
      )}
    </Modal>
  );
};

DeactivateModal.propTypes = {
  handleCloseClick: PropsTypes.func.isRequired,
  show: PropsTypes.bool.isRequired,
  isDeleted: PropsTypes.bool,
  onDeletedSuccess: PropsTypes.func,
  StepTwoComponent: PropsTypes.elementType,
  username: PropsTypes.string,
};

export default DeactivateModal;
